"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.vsOnlyTemplates = void 0;
const templateNames_1 = require("../templateNames");
// these template are only used in visual studio
exports.vsOnlyTemplates = [
    {
        id: "empty-csharp",
        name: templateNames_1.TemplateNames.Empty,
        language: "csharp",
        description: "",
    },
    {
        id: "message-extension-search-csharp",
        name: templateNames_1.TemplateNames.MessageExtensionSearch,
        language: "csharp",
        description: "",
    },
];
//# sourceMappingURL=vs.js.map